import { Component, OnInit, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { SchedeIntenseListConfig, EsperienzeListConfig, Errors, AuthService, Alert, AlertsListConfig, WMAIApiService, AppInformationService } from '../../app/core';
import { WgisService } from '../wgis/wgis.service';
import { WGisDisplayMode } from '../wgis/wgis.utils';
import { Angulartics2 } from 'angulartics2';
import { Subscription } from 'rxjs';
import { PathLocationStrategy } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-home-page',
  templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit {
  isUserLoggedIn = false;
  user_id: string;
  destinazione: string;
  fromDate: string;
  toDate: string;
  loading: boolean = true;
  isSubmitting = false;
  homeSearchForm: FormGroup;
  filters: string;
  isMapVisible = false;
  alerts: Alert[] = [];
  currentAlert: number = 0;
  maxAlert: number = 0;
  alert: Alert;
  idInterval;
  timerInterval: number = 3000;

  subscriptions: Subscription;
  languageSubscription: Subscription;
  
  connectionStatusMessage: string;
  connectionStatus: boolean;

  constructor(
    private router: Router,
    private auth: AuthService,
    private fb: FormBuilder,
    private wgisservice: WgisService,
    private activatedRoute: ActivatedRoute,
    private wmaiservice: WMAIApiService,
    private angulartics2: Angulartics2,
    private appService: AppInformationService,
    private zone: NgZone,
    private activedRoute: ActivatedRoute,
    private translateService: TranslateService
  ) {

    this.connectionStatus = appService.getCurrentConnectionStatus();

    this.homeSearchForm = this.fb.group({
      'destinazione': ['', [Validators.required, Validators.maxLength(15), Validators.minLength(3)]],
      'fromDate': [''],
      'toDate': ['']
    });

    this.isUserLoggedIn = this.auth.isUserLoggedIn();
    this.user_id = this.auth.getIdUser();
    this.wgisservice.clearSelection();
    this.wgisservice.wgisVisible.subscribe((mode: WGisDisplayMode) => {
      this.isMapVisible = (mode !== WGisDisplayMode.Invisible);
    });


    this.angulartics2.eventTrack.next({
      action: 'displaymap',
      properties: { label: 'HomeShowMappa' },
    });

    this.angulartics2.eventTrack.next({
      action: 'submitForm',
      properties: { label: 'HomeSearchSubmit' },
    });
    this.subscribeLanguage();
  }

  listConfig: SchedeIntenseListConfig = {
    type: 'si',
    filters: {}
  };

  esperienzeConfig: EsperienzeListConfig = {
    type: 'exp',
    filters: {}
  };

  alertsConfig: AlertsListConfig = {
    filters: {}
  }

  ngOnInit() {
    window.scrollTo(0, 0);
    this.subscriptions = this.appService.onlineStatus.subscribe(data => {
      this.connectionStatus = data;
    });
    if (this.connectionStatus) {
      this.wgisservice.clearSelection();
      this.isMapVisible = this.wgisservice.getMapVisible();
      this.getAlerts();
    }

    this.activedRoute.queryParams.subscribe(params => {
      if (params['code'] != null && params['code'] != undefined) {
        this.auth.loginIdm(params['code']);
      }
    });
  }

  ngOnDestroy() {
    if (this.subscriptions != null) {
      this.subscriptions.unsubscribe();
    }
  }

  subscribeLanguage(){
    this.languageSubscription = this.translateService.onLangChange.subscribe(() => {
      this.getAlerts();
    })
  }

  getAlerts(){
    this.alerts = [];
    this.alertsConfig.filters.locale = this.translateService.getDefaultLang();
    this.wmaiservice.queryLatestAlerts(this.alertsConfig).subscribe((data) => {
      if (data != null) {
        this.alerts.push(...data);
        this.maxAlert = this.alerts.length - 1;
        if (this.alerts.length > 0) { 
          this.alert = this.alerts[0];
          this.runAlert();
        }
      }
    });
  }
  /**
   * attiva il submit del form e crea una richiesta 
   */
  submitForm() {
    this.isSubmitting = true;
    this.router.navigate(['search'], { queryParams: { destinazione: this.homeSearchForm.controls['destinazione'].value } });
  }
  /**
   * mappa a video
   */
  displaymap() {
    this.wgisservice.cmdToggleMap();
    this.isMapVisible = this.wgisservice.getMapVisible();
  }
  /**
   * prossimo alert
   */
  nextAlert() {
    if (this.currentAlert >= this.maxAlert) this.currentAlert = 0;
    else this.currentAlert++;
    this.alert = this.alerts[this.currentAlert];
    this.runAlert();
  }

  changeAlert(){
    if (this.currentAlert >= this.maxAlert) this.currentAlert = 0;
    else this.currentAlert++;
    this.alert = this.alerts[this.currentAlert];
  }
  /**
   * alert precedente
   */
  previousAlert() {
    if (this.currentAlert <= 0) this.currentAlert = this.maxAlert;
    else this.currentAlert--;
    this.alert = this.alerts[this.currentAlert];
    this.runAlert();
  }
  /**
   * esecuzione alert
   */
  runAlert() {
    if(this.idInterval){
      clearInterval(this.idInterval);
      this.idInterval = null;
    }
    this.idInterval = setInterval(() => {
      this.changeAlert();
    }, 10000);
  }
}
